import React from "react";
import { ArrowRight, Cloud } from "lucide-react";
import Reveal from "./Reveal";
import Stagger from "./Stagger";
import PillField from "./PillField";
import { useLanguage } from "../i18n/LanguageContext";

export default function Problem() {
  const { t } = useLanguage();
  const p = t.problem;

  return (
    <section id="problem" data-testid="problem-section" className="relative overflow-hidden py-24 sm:py-32 border-t border-line">
      <PillField items={t.scale.items} />
      <div className="relative shell">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-5">
            <Reveal className="kicker text-textsoft">{p.kicker}</Reveal>
            <Reveal as="h2" delay={1} className="mt-5 font-display text-[30px] sm:text-[38px] lg:text-[42px] font-semibold text-ink leading-[1.12] tracking-tight">
              {p.h2}
            </Reveal>
            <Reveal as="p" delay={2} className="mt-5 text-[17px] text-textsoft leading-[1.6] max-w-[440px]">
              {p.sub}
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={1}>
              <div className="glow relative rounded-2xl bg-white border border-line p-6 sm:p-8" style={{ boxShadow: "0 30px 70px -34px rgba(15,42,71,0.28)" }}>
                <div className="flex items-center justify-between pb-4 border-b border-dashed border-line-strong">
                  <span className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.16em] text-textsoft">
                    <span className="w-1.5 h-1.5 rounded-full bg-green animate-pulse" />
                    {p.receiptHead}
                  </span>
                  <span className="font-mono text-[11px] text-line-strong">No. 0001</span>
                </div>
                <Stagger as="ul" className="mt-2 divide-y divide-dashed divide-line">
                  {p.rows.map((row) => (
                    <li key={row.old} className="py-4 flex items-center justify-between gap-4">
                      <span className="font-mono text-[12.5px] text-textsoft line-through decoration-line-strong/80">{row.old}</span>
                      <span className="flex items-center gap-2 shrink-0">
                        <ArrowRight size={14} strokeWidth={2} className="text-line-strong" />
                        <span className="pop inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[12px] font-semibold bg-blue-soft text-blue-dark hover:bg-blue hover:text-white">
                          <Cloud size={11} strokeWidth={2} className="opacity-70" />
                          {row.to}
                        </span>
                      </span>
                    </li>
                  ))}
                </Stagger>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
